  import React from 'react';
  import ReactCSSTransitionGroup from 'react-addons-css-transition-group';


  // stateless functional component definition in ES6 way.
  const LoginPs = props => {
    let errMsg = props.showErrMsg ? <h3> { props.errMsg } </h3> : false;
    return (
      <div>
        <span>登入</span>
        <div>
          <ReactCSSTransitionGroup
            transitionName="errMsg"
            transitionEnterTimeout={30}
            transitionLeaveTimeout={10}>
            { errMsg }
          </ReactCSSTransitionGroup>
        </div>
      </div>
    );
  }

  export default LoginPs;



// WEBPACK FOOTER //
// ./src/skyfamily/routes/login/LoginPs.jsx